export enum InputMode {

NUMBER = 'numeric',
PHONE = 'tel',
EMAIL = 'email',
CURRENCY = 'moeda',
}
